import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import { MsalProvider } from "@azure/msal-react";
import Layout from "./components/Layout";
import HomePage from "./pages/Home";
import KnowledgeBasePage from "./pages/KnowledgeBase";
import LoginPage from "./pages/Login";
import { AuthProvider } from "./context/AuthContext";
import SecureRoute from "./components/SecureRoute";
import { oktaAuth, msalInstance } from "./services/authService";
import { config } from "./config";

const App: React.FC = () => {
  // Handle Okta authentication
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    window.location.replace(originalUri || "/");
  };

  // Common routes component
  const AppRoutes = () => (
    <Routes>
      {/* Login callback route */}
      <Route path="/login/callback" element={<LoginCallback />} />

      {/* Login page */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <SecureRoute>
            <Layout>
              <HomePage />
            </Layout>
          </SecureRoute>
        }
      />
      <Route
        path="/knowledge-base"
        element={
          <SecureRoute>
            <Layout>
              <KnowledgeBasePage />
            </Layout>
          </SecureRoute>
        }
      />

      {/* Redirect any unmatched routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );

  // Render based on auth provider
  if (config.auth.provider === "azure" && msalInstance) {
    return (
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </MsalProvider>
      </BrowserRouter>
    );
  }

  // Default to Okta provider
  if (!oktaAuth) {
    return <div>Error: Authentication service not available</div>;
  }

  return (
    <BrowserRouter>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </Security>
    </BrowserRouter>
  );
};

export default App;
